import { createSelector } from '@reduxjs/toolkit'

export const chatPageSelector = state => state.chatPageReducer

export const getDisplayContainer = () =>
  createSelector(chatPageSelector, chatPage => chatPage.display)
